


































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ReturObatNarkotikaDetail extends Vue {
  @Prop() value!: { jumlah_terpakai: number | null; jumlah_sisa_dibuang: number | null };

  update(field: string, val: any) {
    this.$emit("input", { ...this.value, [field]: val ? parseFloat(val) : null });
  }
}
